import { Component } from '@angular/core';
import { CmSettingsService, PortalCoreFeature } from '@ats/cm/core';

@Component({
    selector: 'cm-reload-confirmation',
    templateUrl: './cm-reload-confirmation.component.html',
    styleUrls: ['./cm-reload-confirmation.component.scss'],
    standalone: false
})
export class CmReloadConfirmationComponent {
	readonly locFeature: PortalCoreFeature;

	constructor(private settings: CmSettingsService) {
		this.locFeature = this.settings.portalCoreFeature;
	}
}
